import { render, staticRenderFns } from "./ModalEditRelease.vue?vue&type=template&id=5defbb78&"
import script from "./ModalEditRelease.vue?vue&type=script&lang=js&"
export * from "./ModalEditRelease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports